module.exports = __webpack_public_path__ + "media/images/pages/img_culture_event_01-04542b62f627082c429bd3cbf23fc38b.jpg";